var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "calculator-common", attrs: { id: "calculator-common" } },
    [
      _c(
        "keep-alive",
        [
          _c(_vm.data.currentPage, {
            tag: "component",
            attrs: {
              selectedCalcId: _vm.data.selectedCalc,
              selectedName: _vm.data.selectedName,
              selectedAnswer: _vm.data.selectedAnswer,
              calculatorDefaulSystem: _vm.data.calculatorDefaulSystem,
              systemId: _vm.data.systemId,
              sendYourData: _vm.data.sendYourData,
              sendingProductsData: _vm.data.sendingProductsData,
              sendingAnswerData: _vm.data.sendingAnswerData,
              resetQuestionEngine: _vm.data.resetQuestionEngine,
              isShowPrices: _vm.data.showPrices,
              isShowPricesSelector: _vm.data.showPricesSelector,
              usePartners: _vm.data.usePartners,
              useMyBaumitUser: _vm.data.useMyBaumitUser
            },
            on: {
              selectedAnswer: _vm.onSelectedAnswer,
              selectedCalc: _vm.onSelectedCalc,
              selectCalcName: _vm.onSelectCalcName,
              selectedDetails: _vm.onSelectedDetails,
              backToProduct: _vm.onBackToProduct,
              backToCalcSelector: _vm.onBackToCalcSelector,
              goToDiscounts: _vm.onGoToDiscounts,
              getCalculatorDefaulSystem: _vm.onGetCalculatorDefaulSystem,
              sendYourData: _vm.onSendYourData,
              sendProducts: _vm.onSendProducts,
              sendAnswerData: _vm.onSendAnswerData,
              goToDiscountsFromSelector: _vm.onGoToDiscountsFromSelector,
              nextToThanks: _vm.onNextToThanks,
              backToQuestions: _vm.onBackToQuestions
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }